var canvas, canvas2, text, zoom, cWidth = 1000, cHeight = 1167,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], fontFamily, imageUrl, img;

var loader = jQuery('#customLoader'),
    boxWidth, boxLeft, boxTop, frontShirt, backShirt, thumb,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 280, sizeB1H = 280,
    sizeB2W = 300, sizeB2H = 50;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');

/* Page 2 canvas */
window['canvas2'] = new fabric.Canvas('canvas2',{
  width:cWidth,
  height:cHeight,
  selection: false
});
addModify(window['canvas2']);


var shirtColor = jQuery('input[name="Color"]:checked').val();
url = jQuery('#cricket_shirt_frontside a[data-title="'+shirtColor+'"] img').attr('data-src');

var maxWidth = 280;
var maxHeight = 450;

var thumbChoice = jQuery('#thumbChoice').text(),
    shirtShade, imgURL, fontShade;

var para = "Enter\nYour\nText";

window['text1Page'] = new fabric.Text(para, {
  left: 510,
  top: 370,
  fontSize: 80,
  fontFamily: 'Geometr706',
  textAlign: 'center',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  selectable: false,
});

// Add to canvas
window['canvas2'].add(window['text1Page']);


function getFontShade(shirtColor){
    // Light colors = black text
    let lightColors = ['White', 'Heather Grey', 'Beige', 'Sky Blue'];

    if (lightColors.includes(shirtColor)){
        return 'light';   // text black
    } 
    return 'dark';         // text white
}



function updatefrontShirtImage(){
  var shirtColor = $('input[name="Color"]:checked').val();
  var url = $('#cricket_shirt_frontside a[data-title="' + shirtColor + '"] img').attr('data-src');
  if (window['frontShirt']){
    canvas2.remove(window['frontShirt']);
  }
  if(url){
    fabric.Image.fromURL(url, function(img){
      window['frontShirt'] = img;
      window['frontShirt'].set({
        id: 'frontShirt',
        left: halfWidth,
        top: 390
      });
      window['frontShirt'].scaleToWidth(sizeBmW);
      canvas2.add(window['frontShirt']);
      window['frontShirt'].sendToBack();
      canvas2.renderAll();
    });
  }
}

$(document).on('change', 'input[name="Color"]', function () {
    var shirtColor = $(this).val();

    // Update Hoodie Image
    setTimeout(function () {
        updatefrontShirtImage(shirtColor);
    }, 100); 

    // Detect shade & update text color
    let fontShade = getFontShade(shirtColor);
    updateFontShade(fontShade);
});


updatefrontShirtImage();


var Left, Top, ScaleX, ScaleY, Opacity;
function updateColorShirt(md,imageSRC){
  canvas2.getObjects().forEach((obj) => {
    if(obj.id == md){
      Left = window[md].left;
      Top = window[md].top;
      ScaleX = window[md].scaleX;
      ScaleY = window[md].scaleY;
      Opacity = window[md].opacity;
      canvas2.remove(window[md]);
      fabric.Image.fromURL(imageSRC, function(img){
        window[md] = img;
        window[md].set({
          id: md,
          left: Left,
          top: Top,
          scaleX: ScaleX,
          scaleY: ScaleY,
          opacity: Opacity
        });
        // img.scaleToWidth(sizeB1W);
        canvas2.add(window[md]);
        if(md == 'backShirt'){
          window[md].sendToBack();
        }
        canvas2.renderAll();
      });
    }
  });
}

function updateFontShade(color){
  if(color == 'light'){
    window['text1Page'].set('fill','#000');
  }else{
    window['text1Page'].set('fill','#fff');
  }
  canvas2.renderAll();
}



function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
    // loadFirstImg();
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});

var minFontSize = 10;
var maxFontSize = 170;

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Enter\nYour\nText') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_1').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text1Page'].set({
    text: input
  });
  //fitTextToWidth(window['text1Page'], maxWidth);
  fitTextToBox(window['text1Page'], maxWidth, maxHeight)
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
});

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor');
      activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor');
      activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      
      fontFamily = '';
      fontSize = '';
      canvas = window[colorID];
      updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}



function showExtras(canvas){
  canvas.getObjects().forEach((obj) => {
    if(obj.id == 'backShirt' || obj.id == 'frontShirt'){
      obj.set('opacity',1);
    }
    canvas.renderAll();
  });
}

function hideExtras(canvas){
  canvas.getObjects().forEach((obj) => {
    if(obj.id == 'backShirt' || obj.id == 'frontShirt'){
      obj.set('opacity',0);
    }
    canvas.renderAll();
  });
}

/* fetch Call */
var size,options,optC,optS,fSide;
var loadedObject,wMark,svgMrk,choosedSize,additionalInfo,entertext,chooseFont,fontSize;
var do_frnt,temp_front,orig_front, fImg;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    entertext = jQuery('.enter_text textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    fontSize = jQuery('.font_size option:selected').val();
    choosedSize = jQuery('input[name="Size"]:checked').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    resizeObjects(window['canvas2']);
    const canvasIDs = ['frontS'];
    canvasIDs.forEach((id, index) =>{
      const canvas = window['canvas2'];
      size = 350;
      loadMark(id,canvas,size);
      size = 4000;
      removeMark(id,canvas,size);
      if(index > 0 && index < 3){
        hideExtras(canvas);
      }
      window[id] = canvas.toDataURL('image/png');
      console.log(window[id]);
      if(index > 0 && index < 3){
        showExtras(canvas);
      }
      canvasBlock(canvas);
    });

    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      temp_image: window['frontSt'],
      original_image: window['frontS'],
    })
  })
  .then(response => response.json())
  .then(data => {
    var previewId = data[0],
        extraImg1 = data[1];
    console.log(previewId);
    console.log(extraImg1);
    
    // jQuery('input.product-variant-id[name="id"]').val(optS);
    jQuery('#previewImg').val(previewId);
    jQuery('#preExtraImg').val(extraImg1);
    jQuery('#entertext').val(entertext);
    jQuery('#chooseFont').val(chooseFont);
    jQuery('#fontSize').val(fontSize);
    jQuery('#choosed_size').val(choosedSize);
    jQuery('#addInfo').val(additionalInfo);
    jQuery('.sides_preView').append('<input type="hidden" id="pfExtraImg" name="properties[frnt_image]" value="' + fImg + '">');
    jQuery('.canvas_div').show();
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  })
  .catch(error => console.error('Error uploading images:', error));
  },100);
});

function resizeObjects(canvas){
  fSide = window['text1Page'];
  window['frontShirt'].set('opacity',0);
  fSide.set({
    left: cWidth / 2,
    top: cHeight / 2,
    originX: 'center',
    originY: 'center'
  });
  fSide.scaleToWidth('400');
  canvas.renderAll();
}

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    // canvas.add(loadedObject);
    // loadedObject.bringToFront();
    // loadedObject.setCoords();
    // canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(id,canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}